// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"950":"c80398fc","7529":"cd15c3f8"}[chunkId] + ".chunk.css";
};